import { useFaqWidget } from "../../../providers/context";
import { BookmarkButton } from "~/components/Buttons/BookmarkButton";

export function FaqBookmarkButton() {

	const { 
		hasBookmarked, 
		toggleBookmark 
	} = useFaqWidget();

	return (
		<BookmarkButton
			marked={hasBookmarked()}
			onClick={toggleBookmark}
		/>
	);
}